import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';

import { isTagetCpaHigherThanBudget, getLogString } from './utils';

export const TargetCpaWarningBannerInternal = ({
  budgetAmount,
  cpa,
  activity,
  scenario,
  permissions,
  isSignup, // Remove this prop once TargetCpaValueCheck pilot check is cleaned up
}: {
  budgetAmount: number,
  cpa: number,
  activity: { trace: Function },
  scenario: string,
  permissions: { dynamic: { TargetCpaValueCheck: boolean } },
  isSignup?: boolean,
}) => {
  const i18n: any = useContext(I18nContext);

  const tcpaCheckEnabled = permissions?.dynamic?.TargetCpaValueCheck || isSignup;

  const shouldShowBanner = useMemo(() => {
    const checkValue = isTagetCpaHigherThanBudget(i18n, budgetAmount, cpa);
    activity.trace(getLogString(checkValue, budgetAmount, cpa, scenario, false));
    return checkValue;
  }, [activity, budgetAmount, cpa, i18n, scenario]);

  return (
    tcpaCheckEnabled && shouldShowBanner ? (
      <MessageBar
        intent="warning"
        className="target-cpa-warning-banner"
        style={{
          minHeight: '32px',
          width: '100%',
          wordBreak: 'break-word',
          marginTop: '12px',
        }}
      >
        <MessageBarBody>
          {i18n.getString(_TL_('Your campaign\'s total cost per acquisition is higher than the daily budget, which could prevent you from receiving any conversions. Please consider lowering your total cost per acquisition or raising your daily budget.'))}
        </MessageBarBody>
      </MessageBar>
    ) : null
  );
};

TargetCpaWarningBannerInternal.defaultProps = {
  isSignup: false,
};

export const TargetCpaWarningBanner = withPermissions(TargetCpaWarningBannerInternal);
